// extracted by mini-css-extract-plugin
export default {"root":"styles_root__jBd-0","image":"styles_image__JDPy4"};